<div class="token-indicators">
  <div class="indicator available1">
    <div class="dot"></div>
    <span>Available</span>
  </div>
  <div class="indicator booked1">
    <div class="dot"></div>
    <span>Booked</span>
  </div>
  <div class="indicator pending1">
    <div class="dot"></div>
    <span>Pending</span>
  </div>
</div>
<div class="token-container" style="margin-top: 20px;">
  <div class="form-group token-indicators" style="position: absolute;top: 0;left: 15px;">
    <label for="appointmentDate">Appointmemnt Date</label>
    <p-calendar [(ngModel)]="selectedDate" [minDate]="minDate" id="appointmentDate" style="z-index: 9999;"
      (onSelect)="onDateChange($event)"></p-calendar>
  </div>
  <select class="form-control" *ngIf="slots > 1" (change)="changeSlot($event)" [(ngModel)]="slot">
    <option value="1" selected="slot == 1"> Slot One</option>
    <option value="2" selected="slot == 2">Slot Two</option>
  </select>
  <div class="token" *ngFor="let token of tokens" [ngClass]="getTokenbackgroundClass(token)" type="button"
    (click)="getCurToken(token)" data-toggle="modal" data-target="#myModalappointmnent1">
    <p [ngClass]="getTokenStatusClass(token)">{{ token }}</p>
    <p>{{(getTokenStatusClass(token) === 'booked')?bookedTokenObject[token]:(getTokenStatusClass(token) ===
      'pending')?'Pending':'Available'}}</p>
  </div>
</div>
<div class="modal" id="myModalappointmnent1" style="z-index: 9999;background: #1e1a1a61;">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header" style="background: slategray;color: white;">
        <h4 class="modal-title">Token No. {{curToken}}</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body" style="color: white;background: slategray;">
        <div *ngIf="!showAppt">
          <!-- <div class="form-wrapper"> -->


          <form [formGroup]="recptform1">
            <!-- <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" id="name" formControlName="patientName">
            </div> -->
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <select id="nameTitle" class="custom-select" formControlName="nameTitle">
                  <option value="Mr." selected>Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms.">Ms.</option>
                  <!-- Add more options if needed -->
                </select>
              </div>
              <input type="text" class="form-control" id="name" formControlName="patientName" placeholder="Patient Name" aria-label="Text input with dropdown button">
            </div>
            <!-- <div class="form-group">
              <label for="patientAge">Patient Age:</label>
              <input type="number" id="patientAge" formControlName="patientAge">
            </div> -->
            <div class="row mb-3">
              <div class="col-6 input-group ">
                <!-- <label for="phoneNo"></label> -->
                <input type="number" id="phoneNo" formControlName="phoneNo" placeholder="Phone Number">
              </div>
              <!-- <div class="col-1"></div> -->
              <div class="col input-group ">
                <input type="text" class="form-control" id="name" formControlName="patientAge" placeholder="Patient Age" aria-label="Text input with dropdown button">
                <div class="input-group-prepend">
                  <select id="ageType"  class="custom-select" formControlName="ageType">
                    <option value="year">Year</option>
                    <option value="month">Month</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- <div class="form-group">
              <label for="ageType">Age Type:</label>
              <select id="ageType" formControlName="ageType">
                <option value="year">Year</option>
                <option value="month">Month</option>
              </select>
            </div> -->
            <!-- <div class="form-group">
              <label for="ageType">Gender:</label>
              <select id="ageType" formControlName="patientGender">
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div> -->
            <!-- <div class="form-group">
              <label for="GuardiansName">Guardian's Name:</label>
              <input type="text" id="GuardiansName" formControlName="GuardiansName">
            </div> -->
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <select id="nameTitle" class="custom-select" formControlName="GuardiansNameTitle" style="padding-right: 30px;">
                  <option value="S/O" selected>S/O</option>
                  <option value="D/O">D/O</option>
                  <option value="W/O">W/O</option>
                  <!-- <option value="Ms.">Ms.</option> -->
                  <!-- Add more options if needed -->
                </select>
              </div>
              <input type="text" class="form-control input-group-sm" id="name"  formControlName="GuardiansName" placeholder="Patient Guardian Name" aria-label="Text input with dropdown button">
            </div>

            


            <div class="input-group mb-3">
              <!-- <label for="address">Address:</label> -->
              <input type="text" id="address" formControlName="address" placeholder="Address">
            </div>
            <!-- <div class="form-group">
                    <button type="submit" [disabled]="recptform1.invalid" class="submit-button">Submit</button>
                  </div> -->
          </form>
          <!-- </div> -->


          <div >
            <button class="btn btn-success" *ngIf="!showAdavnce"  type="button" (click)="onAdvance()">Advance
              Options <b>&#9662;</b></button>
              <button class="btn btn-secondary" *ngIf="showAdavnce"  type="button" (click)="onAdvance()">Close
                Options</button>
            <div class="row"  *ngIf="showAdavnce" style="padding: 3px;
            padding-top: 20px;
            color: black;
            background: #efefef;
            border-radius: 10px;
            box-shadow: 1px 5px 9px 0px #373232;
            margin-top: 10px;
            margin-bottom: 10px;
            margin-left: -10px;
            margin-right: -10px;">
              <div class="col-6">
                <label for="member">Member :</label>
                <select class="custom-select custom-select-sm" style="margin-bottom: 10px;padding: 5px;" id="member">
                  <option [value]="member" selected>Select Member</option>
                  <option [value]="member._id" *ngFor="let member of members" selected>{{member.name}}
                  </option>
                </select>
              </div>
              <div class="col-6">
                <label for="tests">Tests :</label>
                <p-multiSelect style="width: 100%;" id="tests" [(ngModel)]="selectedItems" [options]="items"
                  (onChange)="onChangeTests($event)" [defaultLabel]="'Select Tests'"></p-multiSelect>
                <!-- <select class="form-select" style="margin-bottom: 10px;" formControlName="ageType" >
                        <!-- <option value="year" selected>Test 1</option> -->
                <!-- <option value="month">Test 2</option> -->
                <!-- <option value="day">Test 3</option> -->
                <!-- </select> -->
              </div>
              <div class="col-6">
                <label for="Amount">Amount :</label>
                <p>&#8377; {{ammount ? ammount :0}}</p>
                <!-- <input style="margin-bottom: 10px;" disabled type="number" class="form-control form-control-sm" id="Amount" [value]="ammount"
                  (input)="onChangeAmmount($event)" aria-placeholder="Amount" placeholder="Amount" class="form-control"> -->
                <!-- <select class="form-select" style="margin-bottom: 10px;" formControlName="ageType">
                        <option value="year" selected>Years</option>
                        <option value="month">Months</option>
                        <option value="day">Days</option> -->
                <!-- </select> -->
              </div>
              <div class="col-6">
                <label for="discount">Discount :</label>
                <input style="margin-bottom: 10px;" type="number" class="form-control form-control-sm" id="discount"
                  aria-placeholder="Deposit" (input)="onChangeDiscount($event)" placeholder="Discount"
                  class="form-control">
              </div>
              <div class="col-6">
                <label for="Deposit">Deposit :</label>
                <input style="margin-bottom: 10px;" type="clinic name" class="form-control form-control-sm" id="Deposit"
                  aria-placeholder="Deposit" (input)="onChangeDeposit($event)" [value]="deposit" placeholder="Deposit"
                  class="form-control">
              </div>
              <div class="col-6">
                <label for="Balance">Remaining Balance :</label>
                <!-- <input type="text" class="form-control" disabled   id="Balance" formControlName="balance"
                placeholder="Balance" class="form-control"> -->
                <p >&#8377; {{ammount-deposit}}</p>
              </div>
            </div>

            <!-- </div> -->
            <button (click)="Bookreceptionist()" type="buton" [disabled]="(!recptform1.valid)"
              class="btn btn-info pull-right" id="bookrecpt">Book Appointment</button>
          </div>
          <!-- </form> -->
        </div>
        <p style="height: 400px;" *ngIf="isLoading">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </p>
        <div *ngIf="showAppt == true">
          <img style="height: 50px;width: 50px;display: inline-block;" src="../../../assets/success.gif" />
          <h3
            style="color: #00cec9;font-weight: bold;display: inline-block;  margin-bottom: 0;  vertical-align: middle;">
            Successfully booked</h3>
          <table>
            <tbody>
              <tr>
                <td>Name</td>
                <td> : {{" "}}</td>
                <td>{{bookappointment?.patientName +" "+
                  "("+bookappointment.patientAge+bookappointment.ageType+"s"+")"}}</td>
              </tr>
              <tr>
                <td>Token</td>
                <td> : {{" "}}</td>
                <td>{{bookappointment?.appointmentNumber}}</td>
              </tr>
              <tr>
                <td>Phone No.</td>
                <td> : {{" "}}</td>
                <td>{{bookappointment.patientId.phoneNo}}</td>
              </tr>
              <tr>
                <!-- <th scope="row">3</th> -->
                <td>Appointment Date</td>
                <td> : {{" "}}</td>
                <td><b>{{moment(bookappointment.appointmentDate).format('DD/MM/YYYY')}}</b></td>
              </tr>
            </tbody>
          </table>
          <!-- <button type="button" class="btn btn-primary"
              style="padding: 10;display: block !important; margin: 0 auto;"
              (click)="onNewPatient()">New Patient</button> -->
        </div>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>